<ng-template #featureRequestDialogContent>
    <app-feature-request-form />
</ng-template>

<a #pendoAnchor class="feature-request" (click)="requestFeature()">
    <mat-icon svgIcon="speechBubble"></mat-icon>{{ 'sidebar.featureRequest.title' | translate }}
</a>
